export default __webpack_public_path__ + "static/media/settings.e9311a89.svg";